import { VueDate } from '../../views/utils'

function getMonday(date) {
  if (!date) date = new Date()

  const day = date.getDay()
  const diff = (date.getDate() - day) + (day === 0 ? -6 : 1)

  return new Date(date.setDate(diff))
}

export default {
  store: {
    state: {
      activeDay: VueDate(),
      dragged: null,
      viewType: 'Week',
      viewTypes: {
        Day: 1,
        Week: 7,
      },
      offset: null,
      limit: null,
    },
    getters: {
      activeDay: state => state.activeDay,
      dragged: state => state.dragged,
      viewType: (state, { isDesktop }) => isDesktop ? state.viewType : 'Day',
      viewTypes: state => state.viewTypes,

      calHourOffset: (state, { groupSettings }) =>
        state.offset === null
          ? groupSettings.calHoursRange[0]
          : state.offset,

      calHourLimit: (state, { groupSettings }) =>
        state.limit === null
          ? groupSettings.calHoursRange[1]
          : state.limit,

      daysInView: (state, getters) => state.viewTypes[getters.viewType],

      firstDay: (_, { activeDay, viewType }) => VueDate({
        Day: date => date,
        Week: date => getMonday(date),
      }[viewType](new Date(activeDay.obj))),

      lastDay: (_, { firstDay, viewType, viewTypes }) => {
        const date = new Date(firstDay.obj)
        const dateDiff = viewTypes[viewType]

        if (dateDiff > 1) {
          date.setDate(date.getDate() + (dateDiff - 1))
        }

        return VueDate(date)
      },
    },
    actions: {
      DRAG({ state }, dragged) {
        state.dragged = dragged
      },
      HOUR_LIMIT({ commit }, limit) {
        commit('SET_HOUR_LIMIT', limit)
      },
      HOUR_OFFSET({ commit }, offset) {
        commit('SET_HOUR_OFFSET', offset)
      },
      SHIFT_ACTIVE_DAY({ getters, commit }, dayAmountMultiplier) {
        const date = new Date(getters.firstDay.obj)
        date.setDate(date.getDate() + (dayAmountMultiplier * getters.daysInView))
        commit('SET_ACTIVE_DAY', VueDate(date))
      },
      // SET_ACTIVE_DAY({ commit }, activeDay) {
      //   commit('SET_ACTIVE_DAY', activeDay)
      // },
      VIEW_TYPE({ commit }, viewType) {
        commit('SET_VIEW_TYPE', viewType)
      },
    },
    mutations: {
      SET_ACTIVE_DAY(state, activeDay) {
        state.activeDay = activeDay
      },
      SET_HOUR_LIMIT(state, limit) {
        state.limit = limit
      },
      SET_HOUR_OFFSET(state, offset) {
        state.offset = offset
      },
      SET_VIEW_TYPE(state, viewType) {
        state.viewType = viewType
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/calendar.js